import React from "react"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"
// "gatsby": "^2.24.47",
const Seo = ({
  title: blogTitle,
  description: blogDescription,
  image: blogImage,
  pathname,
  article,
}) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            defaultTitle: title
            defaultDescription: description
            author {
              name
              summary
            }
            titleTemplate
            defaultImage: image
            siteUrl
            keywords
            social {
              twitter
              instagram
              linkedin
            }
          }
        }
      }
    `
  )

  const {
    defaultTitle,
    defaultDescription,
    siteUrl,
    social,
    titleTemplate,
  } = site.siteMetadata
  const { twitter } = social

  const title = blogTitle || defaultTitle
  const image = blogImage?.src
    ? siteUrl + blogImage.src
    : siteUrl + "/jayGurav.jpg"
  const description = blogDescription || defaultDescription
  const url = pathname ? siteUrl + pathname : siteUrl

  return (
    <Helmet
      title={title}
      titleTemplate={titleTemplate}
      htmlAttributes={{ lang: "eng" }}
      meta={[
        { name: "description", content: description },
        { name: "image", content: image },

        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:image", content: image },

        { property: "twitter:title", content: title },
        { property: "twitter:image", content: image },
        { name: "twitter:description", content: description },
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:url", content: url },
        { name: "twitter:site", content: "@JayMGurav" },
        { name: "twitter:domain", content: siteUrl },
        { name: "twitter:creator", content: twitter },
      ]}
      link={[{ rel: "canonical", href: url }]}
      defer={false}
    />
  )
}

export default Seo;
